/**
 * Phase 29.2 §A — QuickTab simplified to ATDE Assistant launcher only.
 *
 * Single responsibility: one-click opens the ATDE Assistant chat panel.
 * No icon-selection layer, no notes branching. Pinned Notes is reached
 * from the per-page sidebar trigger.
 */
import React from 'react';
import ReactDOM from 'react-dom';
import { MessageSquare } from 'lucide-react';

export default function QuickTab() {
  const openAssistant = () => {
    window.dispatchEvent(new CustomEvent('atde:open-chat'));
  };

  return ReactDOM.createPortal(
    <button
      data-testid="quicktab-trigger"
      onClick={openAssistant}
      title="Open ATDE Assistant"
      className="fixed z-[56] right-3 bottom-3 pointer-events-auto flex items-center gap-2 px-4 py-2 text-[11px] uppercase tracking-[0.25em] font-mono border bg-black/90 text-cyan-sys border-cyan-sys hover:bg-cyan-sys hover:text-black transition-colors"
      style={{ borderRadius: '999px',
               boxShadow: '0 0 10px rgba(8,247,254,0.3)' }}
    >
      <MessageSquare size={12} />
      <span>ATDE Assist</span>
    </button>,
    document.body
  );
}
